<script setup>
import JobList from 'components/JobList.vue';
import { useJobViewerStore } from 'stores/job-viewer-store';
import { computed } from 'vue';

const $props = defineProps({
    jobScopeId: {
        type: Number,
        required: true
    }
});

const jobViewerStore = useJobViewerStore();

// Only display an even number of jobs.
const slicedJobs = computed(() => {
    const jobs = jobViewerStore.similarJobs;
    if (jobs.length < 2) {
        return [];
    }
    return jobs.length % 2 === 0
        ? jobs
        : jobs.slice(0, jobs.length - 1);
});

defineExpose({
    isVisible: computed(() => slicedJobs.value.length > 0)
});
</script>

<template>
    <div v-if="slicedJobs.length >= 2" class="more-jobs-section container-md q-px-md q-py-xl">
        <JobList :jobs="slicedJobs" :is-loaded="slicedJobs.length > 0" split minimal/>
    </div>
</template>
